import fp from 'lodash/fp';
import { businessActions } from '../../../state/modules/business';
import { createDownloadBusinessActivityButton } from './create-download-business-activity-button';
const stateSelectors = ({ industry, publisher, business }) => ({
  publishers: publisher.publishers,
  industriesWithCpdCategorys: fp.get('industriesWithCpdCategorys')(industry),
  isFetching: business.isFetchingBusinessActivities,
  businessActivities: business.businessActivities
});

export default createDownloadBusinessActivityButton({
  getBusinessActivities: businessActions.business.getBusinessActivities,
  cleanBusinessActivities: businessActions.business.cleanBusinessActivities,
  stateSelectors
});



// WEBPACK FOOTER //
// ./src/containers/pages/shared/download-business-activity-button-for-business.js